import { ComponentClass } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { AppState } from '~src/app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { ResourceGovernanceOwnProps, ResourceGovernanceStateProps, ResourceGovernanceSubspace,ResourceGovernanceSubspaceDispatchProps } from './ResourceGovernanceSubspace';


const mapStateToProps: MapStateToProps<ResourceGovernanceStateProps> = (state: AppState) => ({
  isFirstRun: state.contentExplorer.content.contentItems.length === 0,
});
const mapDispatchToProps: MapDispatchToProps<ResourceGovernanceSubspaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents: requestSpaceContents
}, dispatch);

export const ConnectedResourceGovernanceSubspace: ComponentClass<ResourceGovernanceOwnProps> = connect(mapStateToProps, mapDispatchToProps)(ResourceGovernanceSubspace);
